import type { NextPage } from 'next';

import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';

import JobBoardPageProps from '@domains/job-board/types/job-board-page';

import { JobDetailsProvider } from '@shared/context/job-details.context';

import JobList from 'domains/job-board';
import JobsPageHub from 'domains/job-board/components/jobs-page-hub/JobsPageHub';

const JobListingsPage: NextPage<JobBoardPageProps> = ({
  jobTitle,
  pflegefachkraftRoleGroup,
  location,
  typeOfWork,
  pageNumber,
  nearbyCities,
  initialTotal,
  jobTitlePage,
  seoMeta,
}) => {
  const { isPraxia } = useFlavorFromRoute();

  return (
    <JobDetailsProvider>
      {!isPraxia && pageNumber === 1 && !jobTitle && !pflegefachkraftRoleGroup && !location && !typeOfWork ? (
        <JobsPageHub />
      ) : (
        <JobList
          jobTitle={jobTitle}
          pflegefachkraftRoleGroup={pflegefachkraftRoleGroup}
          location={location}
          typeOfWork={typeOfWork}
          namespace='jobListings'
          slimmed
          nearbyCities={nearbyCities}
          initialTotal={initialTotal}
          jobTitlePage={jobTitlePage}
          seoMeta={seoMeta}
        />
      )}
    </JobDetailsProvider>
  );
};

export { getServerSidePropsJobsList as getServerSideProps } from '@domains/job-board/utils/get-server-side-props-jobs';
export default JobListingsPage;
